/**
 * Sonda de conectividad del tótem.
 *
 * La sonda existe para responder a una sola pregunta —«¿hay internet?»— antes de
 * abrir algo que lo necesita (un folleto, la encuesta, el mapa de calle, el selfie).
 * Por eso pide SIEMPRE un recurso fijo y diminuto, `environment.connectivityProbeUrl`,
 * y nunca el contenido que el visitante acaba de tocar: con un tope de dos segundos,
 * pedir el contenido convierte la pregunta en «¿cabe este fichero en dos segundos?».
 *
 * Medido en Marbella el 4-sep-2026 (HRS-3148): los tres tótems de la Oficina del Faro
 * daban «Sin conexión a internet» al abrir folletos, y los dos únicos que abrían eran
 * exactamente los dos más pequeños de los trece (0,62 MB y 1,12 MB). El que reportó el
 * cliente pesa 3,71 MB, y hay otros de 15,93 y 22,21 MB. Contra producción, los 23
 * ficheros (es+en) responden 200 `application/pdf` y bajan completos: el servidor no
 * tenía nada que ver, y la petición del fichero no llegaba a salir del equipo.
 */

/**
 * Tope de espera de la sonda. Solo es seguro porque el destino es un recurso fijo de
 * unos pocos KB; aplicado a un fichero de contenido, mide el tamaño, no la red.
 */
export const PROBE_TIMEOUT_MS = 2000;

/**
 * Un error de la sonda que, en realidad, prueba que hay internet.
 *
 * La petición se hace esperando JSON, así que un cuerpo que no lo sea llega aquí como
 * error aunque el servidor haya contestado. Si trae `status` 200, la red respondió y
 * eso es lo único que la sonda quería saber.
 */
export function probeSaysOnline(error: any): boolean {
  return error?.status === 200;
}
